import {Storage} from "@/services/Storage";
import axios from "axios";

export default {
    name: 'stock',
    state: {
        stock: [],
        stockSetting: [],
        stockItem: {},
        stockCache: new Map(),
        stockLength: 1
    },
    getters: {
        getStockProducts: (state) => {
            let items = state.stock;
            let products = [];
            for (let i = 0; i < items.length; i++){
                let item = products.find(p=>p.PLU===items[i].PLU);
                if (!item){
                    products.push(items[i]);
                }
            }
            return products;
        },
        getAllStockProducts: ({stockCache}) => [...stockCache.values()],
        getStockItem: (state) => state.stockItem,
        getStockSetting: (state) => state.stockSetting,
        getStockLength: (state) => state.stockLength,
        getByPlu: (state) => (plu) => {
            // const item = state.stockCache.get(plu.toLowerCase());
            const item = state.stockCache.get(plu.toLowerCase());
            if (item === null) {
                return state.stock.find(stockItem => stockItem.PLU.toLowerCase() === plu.toLowerCase());
            }
            return item;
        },
    },

    mutations: {
        stockByPLU: async (state, payload) => {
            if (payload) {
                payload.sort((a, b) => a.Description.localeCompare(b.Description))
                await Storage.stockByPLU(payload);

                state.stock = payload.filter(x => x.FastLine === 1)
                    .sort((a, b) => a.Description.localeCompare(b.Description));
                //state.allStock = payload
                state.stockCache = payload.reduce((mapAcc, obj) => {
                    mapAcc.set(obj.PLU.toLowerCase(), obj);
                    return mapAcc;
                }, new Map())

            } else {
                await Storage.getFastLine().then(res => {
                    state.stock = res.sort((a, b) => a.Description.localeCompare(b.Description))
                })
            }
        },
        setStockSetting: async (state, payload) => {
            if (payload) {
                state.stockSetting = payload;
            }
        },
        setSearch: (state, payload) => {
            state.stock = payload.sort((a, b) => a.Description.localeCompare(b.Description))
        },
        setStockItem: (state, payload) => {
            state.stockItem = payload
        },
        setStockLength: (state, payload) => {
            state.stockLength = payload
        },
        addStockItem: (state, payload) => {
            Storage.getAllStock().then(stock => {
                state.stock = state.stock.map(s => {
                    if (s.PLU === payload.PLU) {
                        return payload;
                    }
                    return s;
                })
                return Storage.stockByPLU(state.stock);
            });
        }
    },
    actions: {
        addStockItem: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            try {
                delete payload.CreatedUser
            } catch (e) {
                console.error(e)
            }
            return axios.post(`${serverApi}stock/${store.StoreDB}`, payload)
                .then(({data}) => {
                    context.commit('addStockItem', data);
                    context.commit('setStockItem', data);
                    return data;
                })
                .catch((err) => errorHandler.tomcatError(err)).finally(() => context.dispatch('getAllStock'))
        },
        getStockSetting: (context, plu) => {
            return Storage.getStockSetting(plu)
        },
        getAllStock: async (context) => {
            let store = await Storage.getDefaultStore();
            let device = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            if (!store) return;
            // let url = `https://overflow.pos.co.zm:8443/OnlineSalesServer/` + `stock/${store.StoreDB}`;
            let url = serverApi + `stock/${store.StoreDB}`;
            return axios.get(url, {params: {pc: device.PC,user : user?user.Username:undefined}})
                .then(async ({data}) => {
                    const stockSettings = data.map(s => {
                        let set = s.StockSetting
                        if (set) {
                            return {

                                plu: s.PLU,
                                cookingLink: set.CookingLink,
                                mtv: set.mtv,
                                askForPrice: set.askForPrice,
                                askForDescription: set.askForDescription,
                                askForBoth: set.askForBoth,
                                NonStock: set.NonStock,
                                tourism: set.tourism,
                                getQtyFromPrice: set.getQtyFromPrice,
                                password_protected: set.password_protected
                            }
                        } else {
                            return {
                                plu: s.PLU,
                                mtv: 0.00,
                                tourism: false,
                                NonStock: false,
                                cookingLink: false,
                                askForPrice: false,
                                askForDescription: false,
                                askForBoth: false,
                            }
                        }
                    })
                    const stock = data.map(s => {
                        delete s.CreatedDate
                        delete s.Image
                        delete s.Price1
                        delete s.Price2
                        delete s.Price3
                        delete s.Price4
                        delete s.Price5
                        delete s.args
                        delete s.where_between
                        delete s.StockSetting
                        return s;
                    });
                    // Convert the array into an object keyed by PLU
                    const stockByPLU = stock.reduce((acc, item) => {
                        acc[item.PLU] = item;
                        return acc;
                    }, {});

                    await context.commit('stockByPLU', stock);
                    await context.commit('setStockSetting', stockSettings);
                    context.dispatch(`setStockImages`)
                }).catch((err) => errorHandler.tomcatError(err))
        },
        searchStock: (context,  { query = {}, limit, offset }) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            context.commit('setCurrentCategory', query.category)
            context.commit('setSubCategory', query.subCategory)
            context.commit('setSubCategory2', query.sub2Category)
            return Storage.searchStock(query,limit,offset).then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },
        searchDescription: (context, query) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            context.commit('setCurrentCategory', query.category)
            context.commit('setSubCategory', query.subCategory)
            context.commit('setSubCategory2', query.sub2Category)
            return Storage.searchStockDesc(query).then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },

        searchDepartment: async (context, query) => {
            let search = context.getters.getSearchCategories;
            query.category = search.category;
            query.subCategory = search.subCategory;
            query.sub2Category = search.sub2Category;

            query.description = '';
            return Storage.searchStockDesc(query).then((value => value));
        },

        getFastLine: (context, query) => {
            context.commit(`setSearchCategories`, {
                category: ``,
                subCategory: ``,
                sub2Category: ``
            })
            return Storage.getFastLine().then(res => {
                context.commit('setSearch', res)
            }).catch(err => console.error(err))
        },

        setStockImages: async (context) => {
            let store = await Storage.getDefaultStore();
            let stockItems = await Storage.getAllStock();
            let images = [];

            // Build image URLs directly instead of downloading base64
            stockItems.filter(stock => stock.hasImage).forEach(item => {
                const url = `https://overflow.pos.co.zm/Franchise_OnlineServer/stock/${store.StoreDB}/image?plu=${item.PLU}`;
                images.push({ PLU: item.PLU, Image: url });
            });

            await Storage.setStockImages(images);
            context.commit(`stockByPLU`)
        },
    }
}
